<template>
  <div class="RwvContentImage" v-bind:class="{ small: image.small }">
    <b-img-lazy :src="image.data" :title="image.title" :alt="image.title"/>
    <h3 v-if="image.showTitle">{{image.title}}</h3>
    <p v-if="image.showDescription">{{image.description}}</p>
  </div>
</template>

<script>
export default {
  name: "RwvContentImage",
  props: {
    image: {
      type: Object,
      required: true
    }
  },
  methods: {
    parseMarkdown(markdown) {
      return marked(markdown);
    }
  }
};
</script>

<style lang="scss" scoped>
  .RwvContentImage {
    display: block;
    margin: 20px auto;
    img {
      max-width: 100%;
      max-height: 600px;
      margin: auto;
    }
    &.small {
      max-width: 300px;
    }
  }
</style>
